<template>
    <v-container :fluid="$vuetify.breakpoint.md" class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col cols="12" lg="10">
                <v-card>
                    <v-card-title class="d-block text-center font-weight-bold primary secondary--text pa-1" style="word-break: normal">CONDICIONES</v-card-title>
                    <v-btn bottom color="secondary primary--text" depressed fab absolute right small @click="getData">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                    <v-card-text class="pa-4">
                        <v-progress-linear indeterminate v-if="loading"/>
                        <v-list two-line class="pa-0" v-else>
                            <v-list-item>
                                <v-list-item-avatar color="secondary">
                                    <v-icon color="primary">mdi-script-text</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title class="font-weight-bold primary--text">
                                        {{ settings.enabled ? 'Recompensas activas' : 'Recompensas inactivas' }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Minimo {{ settings.min_redeem_points }} puntos. Valor por punto: {{ settings.point_value_usdt }} USDT.
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-avatar color="secondary">
                                    <v-icon color="primary">mdi-play-circle</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title class="font-weight-bold primary--text">Videos recompensados</v-list-item-title>
                                    <v-list-item-subtitle>
                                        Maximo diario: {{ settings.max_daily_rewards }}. Espera: {{ settings.cooldown_minutes }} minuto(s).
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <v-btn color="primary" class="mt-4" to="/settings/rewards" v-if="user.role === 'Administrator'">
                            <v-icon>mdi-cog</v-icon>&nbsp;&nbsp;Configurar
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    name: "Conditions",
    props: ['user'],
    data: () => ({
        loading: true,
        settings: {
            enabled: false,
            min_redeem_points: 0,
            point_value_usdt: 0,
            max_daily_rewards: 0,
            cooldown_minutes: 0
        }
    }),
    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.loading = true;
            axios.get('/api/rewards/admin').then(res => {
                const rewards = res.data.rewards || {};
                this.settings = Object.assign({}, this.settings, rewards.settings || {});
            }).catch(err => {
                this.$toast.error(this.errorMessage(err, 'No fue posible cargar condiciones.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.loading = false;
            });
        },
        errorMessage(err, fallback) {
            if (err.response && err.response.data && err.response.data.status) {
                return err.response.data.status;
            }

            return fallback;
        }
    }
}
</script>

<style scoped>

</style>
